import '../my_teams_list/index_web.css';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'underscore';
import { showToast } from '../../../actions/app-actions-types';
import EventEmitter from '../../../utilities/EventEmitter';
import { getRouteObjByGame, isSmartPhone } from '../../../utilities/helper';
import useGame from '../../../utilities/hooks/game';
import I18n from '../../../utilities/locale';
import { useLink } from 'react-router-stack';
import constants from '../../../constants';
import MyTeamsListMWeb from './index_mWeb';
import MyTeamsListWeb from './index_web';

const MyTeamsList = () => {
  const navigate = useLink();
  const { teamName = '' } = useSelector((state: any) => state.user);
  const { item: matchItem, fantasyMatchClick, gameType } = useGame();

  const {
    _id: matchId,
    contestId,
    entryFee,
    bonusPercentage = 0,
    isTeamSwitch = false,
    competition = {},
    contestTeams = [],
    tabType = ''
  } = matchItem;

  const { title = '' } = competition;
  const [myTeamList, setMyTeamList] = useState([] as any);
  const dispatch = useDispatch();
  const [matchAllPlayersList, setMatchAllPlayerList] = useState([]);
  const [error, setError] = useState(false);
  const [lineupsOut, setLineupsOut] = useState(false);
  const totalTeamsCount = myTeamList.length;
  const { myTeamList: fantasyCricketMyTeamsList, playerList: fantasyCricketPlayerList } =
    useSelector((state: any) => state.fantasy_cricket);
  const { myTeamList: fantasyFootballMyTeamsList, playerList: fantasyFootballPlayerList } =
    useSelector((state: any) => state.fantasy_football);
  useEffect(() => {
    getMyTeamList({});
    getAllPlayerListAPI();
    EventEmitter.on('teamUpdate', getMyTeamList);
    return () => {
      EventEmitter.off('teamUpdate', getMyTeamList);
    };
  }, [fantasyCricketMyTeamsList, fantasyFootballMyTeamsList]);

  const getAllPlayerListAPI = () => {
    let result: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      result = fantasyCricketPlayerList[matchItem._id];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      result = fantasyFootballPlayerList[matchItem._id];
    }
    if (!error && result) {
      setMatchAllPlayerList(result);
      ///this is for calculate line up out
      let playingPlayersList = [];
      playingPlayersList = result.filter(
        (player: { playingEleven: boolean }) => player.playingEleven === true
      );
      setLineupsOut(playingPlayersList.length >= 15);
    } else {
      setError(true);
    }
  };

  const getMyTeamList = async ({ latestTeamData = { id: '' } } = {}) => {
    let result: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      result = fantasyCricketMyTeamsList[matchItem['_id']];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      result = fantasyFootballMyTeamsList[matchItem['_id']];
    }
    if (result) {
      const { id = '' } = latestTeamData;
      let isNotExistLatestTeam = _.findWhere(result, { id });
      if (id && !isNotExistLatestTeam) {
        // result.push(latestTeamData);
      }
      result.sort((a: { teamNumber: number }, b: { teamNumber: number }) =>
        a.teamNumber > b.teamNumber ? 1 : -1
      );
      setMyTeamList(result);
      setError(false);
    } else {
      setError(true);
    }
  };

  const onPressPreview = (teamData: any, teamNumber: any) => {
    navigate.push(getRouteObjByGame(gameType)['team_preview'], {
      teamData: { ...teamData, username: teamName },
      matchId,
      teamNumber,
      item: matchItem,
      fromCreateTeam: false,
      lineupsOut,
      matchAllPlayersList,
      gameType
    });
  };

  const onPressClone = (teamData: { players?: never[] | undefined }, teamNumber: any) => {
    const { players = [] } = teamData;
    let playerList: { id: any; playerId: any }[] = [];
    players.forEach((item: { id: any; playerId: any }) => {
      playerList.push({
        id: item.id,
        playerId: item.playerId
      });
    });

    if (totalTeamsCount < 11) {
      dispatch(
        fantasyMatchClick({
          data: {
            ...matchItem,
            selectedTeamPlayers: playerList,
            isEdit: false,
            teamNumber,
            isClone: true,
            joinedMatch: false,
            entryFee,
            contestId,
            teamData: {
              ...teamData,
              teamNumber: totalTeamsCount + 1
            },
            bonusPercentage,
            isTeamSwitch,
            isFromMyTeam: true
          }
        })
      );
      navigate.push(getRouteObjByGame(gameType)['create_team']);
    } else {
      dispatch(showToast(I18n.t('maxTeamMsg')));
    }
  };

  const onPressEdit = (teamData: { players?: never[] | undefined }, teamNumber: any) => {
    const { players = [] } = teamData;
    let playerList: { id: any; playerId: any }[] = [];
    players.forEach((item: { id: any; playerId: any }) => {
      playerList.push({
        id: item.id,
        playerId: item.playerId
      });
    });

    dispatch(
      fantasyMatchClick({
        data: {
          ...matchItem,
          selectedTeamPlayers: playerList,
          isEdit: true,
          teamNumber,
          joinedMatch: false,
          isClone: false,
          entryFee,
          contestId,
          teamData,
          bonusPercentage,
          isTeamSwitch,
          isFromMyTeam: true
        }
      })
    );
    navigate.push(getRouteObjByGame(gameType)['create_team']);
  };

  return (
    <>
      {isSmartPhone ? (
        <MyTeamsListMWeb
          myTeamList={myTeamList}
          onPressPreview={onPressPreview}
          onPressClone={onPressClone}
          onPressEdit={onPressEdit}
          lineupsOut={lineupsOut}
          title={title}
          matchAllPlayersList={matchAllPlayersList}
          contestTeams={contestTeams}
          gameType={gameType}
          tabType={tabType}
        />
      ) : (
        <MyTeamsListWeb
          myTeamList={myTeamList}
          onPressPreview={onPressPreview}
          onPressClone={onPressClone}
          onPressEdit={onPressEdit}
          lineupsOut={lineupsOut}
          title={title}
          matchAllPlayersList={matchAllPlayersList}
          contestTeams={contestTeams}
          gameType={gameType}
          tabType={tabType}
        />
      )}
    </>
  );
};

export default MyTeamsList;
